<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
        <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

       <qr-edit-gateway
      v-model="showGatewayPopup"
      :sections="specialInfoSingle"
      :form-data="data"
      @edit-all="handleEditAll"
      @save="qrUpdate(true)"
      @cancel="onCancel"
    >
    <template v-slot:preview style="position: relative; min-height: 100%;">
      <div class="sticky-preview">
          <text-mobile v-model="data" :orders.sync="data.orders" :qr-svg-data-url="qrSvgDataUrl"/>
        </div>
    </template>
    </qr-edit-gateway>
      <v-row class="mx-auto pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
        <text-mobile v-model="data"  :orders.sync="data.orders" :qr-svg-data-url="qrSvgDataUrl"/>
        </v-col>

        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات کیوآر متن</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام کیوآر متن"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام کیوآر متن"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="آدرس کیوآر"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                    @save-required="AutoSave && qrUpdate(false)"

                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import TextMobile from "./component/TextMobile.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions } from "vuex";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";


export default {
  name: "editText",

  components: {
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    TextMobile,
    QrMaker,
    QrEditGateway,
    AtomSpinner
    
  },

  data() {
    return {
      qrSvgDataUrl: false,
      isAutoSaving: false, 
      AutoSave:false,
    
      orders: [],
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      helpData: [],
      serviceName: "Qrland",
      componentName: "editText",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {
        designSettings: {
          theme: null,
          layout: null
        },
        orders: []
      },
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },      
    };
  },

  mounted() {
    this.fetchData();
  },  
  computed: {
    specialInfo() {
      return [
        {
          name: "baseInfo",
          value: "",
          title: this.$t("edit_bpage_special_info_special.text"),
          icon: "text",
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t("edit_bpage_special_info_special.logo_background"),
          icon: "image",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: this.$t("edit_bpage_special_info_special.select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ];
    },
   specialInfoSingle() {
  return [
    {
      name: "baseInfo",
      value: "",
      title: this.$t(
        "edit_text_special_info_single.base_info_title"
      ),
      subtitle: this.$t(
        "edit_text_special_info_single.base_info_subtitle"
      ),
      icon: "text",
      description: this.$t(
        "edit_text_special_info_single.base_info_description"
      ),
    },

    {
      name: "imageUploader",
      value: "",
      title: this.$t(
        "edit_text_special_info_single.image_uploader_title"
      ),
      subtitle: this.$t(
        "edit_text_special_info_single.image_uploader_subtitle"
      ),
      icon: "image",
      model: "photo",
      description: this.$t(
        "edit_text_special_info_single.image_uploader_description"
      ),
    },

    {
      name: "colorPallete",
      value: "",
      title: this.$t("select_color"),
      subtitle: this.$t(
        "edit_text_special_info_single.color_palette_subtitle"
      ),
      icon: "format-color-fill",
      model: "pallete",
      description: this.$t(
        "edit_text_special_info_single.color_palette_description"
      ),
    },
  ];
},
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },


  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
      onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

      fetchData() {
      this.loading = true;
      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 

          let info = data.data.data.data || {};

          if (!info.orders || info?.orders?.length === 0) {
            this.$set(info, 'orders', [        
              { name: 'profile' },
              { name: 'about' },
              { name: "extraFields" },
          ]);
          }
          this.data = info;
          this.res = data.data;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات!");
          console.log("error in get data: ", response);
        })
        .finally(() => (this.loading = false));
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "text");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append("_method", "PUT");
      data.append("title", this.data.visitName);

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if(final || !this.AutoSave)
            this.$toast.success("کیوآر متن شماباموفقیت ویرایش شد.");
          if(final)
            this.goto("qr/list");
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;

        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;

        });
    },
  },
};
</script>

<style scoped></style>
